import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconArrowDownWithColorComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-ArrowDownWithColor${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path fillRule="evenodd" clipRule="evenodd" d="M7.70875 11.201C7.84173 11.3751 8.10362 11.3757 8.23749 11.2023L11.1767 7.39529C11.3458 7.17616 11.1897 6.85825 10.9128 6.85825H9.33333V2.99872C9.33333 2.81462 9.18409 2.66538 9 2.66538H7C6.8159 2.66538 6.66667 2.81462 6.66667 2.99872V6.85825H5.06539C4.78935 6.85825 4.63293 7.17458 4.8005 7.39394L7.70875 11.201Z" fill={useCurrentColor ? 'currentColor' : '#E14653'}/></svg>;
}

const IconArrowDownWithColor = React.forwardRef(IconArrowDownWithColorComponent);
export default IconArrowDownWithColor;
